<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Cuadro General</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter  v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Tipo:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option value="siempre">Rojo</option>
          <option value="hoy">Blanco</option>
        </select>       
      </search-filter>
      <inertia-link v-if="$page.props.auth.user.rol =='Admin'" class="btn-indigo" :href="route('cuadros')">
        <span>Crear</span>
        <span class="hidden md:inline">Nuevo Rojo</span>
      </inertia-link>
      <inertia-link v-if="$page.props.auth.user.rol =='Admin'" class="btn-indigo" :href="route('cuadros')">
        <span>Crear</span>
        <span class="hidden md:inline">Nuevo Blanco</span>
      </inertia-link>
    </div>
    <br>
      <br>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap table-bordered">
        <tr class="border-t text-center font-bold">
           <th class="border-r px-6 pt-6 pb-4">Nº día  </th>
           <th class="border-r px-6 pt-6 pb-4">Tipo</th>
          <th class="border-r px-6 pt-6 pb-4">Origen</th>
          <th class="border-r px-6 pt-6 pb-4">Destino</th>
          <th class="border-r px-6 pt-6 pb-4">Hora</th>
           <th class="border-r px-6 pt-6 pb-4">Despacho</th>
           <th class="border-r px-6 pt-6 pb-4">Detalle</th>
        </tr>
        <tr v-for="diario in diarios.data" :key="diario.id" class="border-t hover:bg-gray-100 focus-within:bg-gray-100">
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
                {{ diario.dia }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
                {{ diario.tipo }}
            </inertia-link>
          </td>
         <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              {{ diario.origen }}
            </inertia-link>
          </td>
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
                {{ diario.destino }}     
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              {{ diario.hora }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              {{ diario.despacho }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              {{ diario.detalle }}
            </inertia-link>
          </td>  
          <td class="border-r w-px">
            <inertia-link class="px-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="diarios.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron ingresos</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="diarios.links" />
<br>
<br>
      <br>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap table-bordered">
        <tr class="border-t text-center font-bold">
           <th class="border-r px-6 pt-6 pb-4">Nº día  </th>
           <th class="border-r px-6 pt-6 pb-4">Tipo</th>
          <th class="border-r px-6 pt-6 pb-4">Origen</th>
          <th class="border-r px-6 pt-6 pb-4">Destino</th>
          <th class="border-r px-6 pt-6 pb-4">Hora</th>
           <th class="border-r px-6 pt-6 pb-4">Despacho</th>
           <th class="border-r px-6 pt-6 pb-4">Detalle</th>
        </tr>
        <tr v-for="diario in diariosrojo.data" :key="diario.id" class="border-t hover:bg-gray-100 focus-within:bg-gray-100">
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
                {{ diario.dia }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
                {{ diario.tipo }}
            </inertia-link>
          </td>
         <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              {{ diario.origen }}
            </inertia-link>
          </td>
           <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
                {{ diario.destino }}     
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              {{ diario.hora }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              {{ diario.despacho }}
            </inertia-link>
          </td>
          <td class="border-r">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              {{ diario.detalle }}
            </inertia-link>
          </td>  
          <td class="border-r w-px">
            <inertia-link class="px-4 flex items-center" :href="route('cuadros.edit', diario.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="diariosrojo.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron ingresos</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="diarios.links" />
<br>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Cuadro General' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    diarios: Object,
    diariosrojo: Object,

  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        tipo: 'Cuadro',
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('cuadros'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
